export default class MobileNavbar {
    static init(): void {
        const mobileNavbar = document.querySelector('#mobile-navbar');
        if (!mobileNavbar) return;
        const navbarDropdownToggles = mobileNavbar.querySelectorAll('.navbar-dropdown-toggle');

        navbarDropdownToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const dropdownMenu = toggle.nextElementSibling;
                if (dropdownMenu && dropdownMenu.classList.contains('navbar-dropdown-menu')) {
                    dropdownMenu.classList.toggle('navbar-dropdown-menu--show');
                    toggle.classList.toggle('navbar-dropdown-toggle--active');
                }
            });
        });


    }
}
